import { createReducer } from "../../../generic/redux/createReducer";
import { pairActionTypeToReducer } from "../../../generic/redux/TypedRedux";

import type { CloseSettings, OpenSettings } from "./VisualizerActions";
import { CLOSE_SETTINGS, OPEN_SETTINGS } from "./VisualizerActionTypes";
import { type VisualizerState, initialVisualizerState } from "./VisualizerState";

const toggleSettingsReducer = (state: VisualizerState, { type }: OpenSettings | CloseSettings): VisualizerState => ({
	...state,
	settings: {
		open: type !== CLOSE_SETTINGS,
	},
});

export const VisualizerReducer = createReducer<VisualizerState>(initialVisualizerState, {
	...pairActionTypeToReducer(OPEN_SETTINGS, toggleSettingsReducer),
	...pairActionTypeToReducer(CLOSE_SETTINGS, toggleSettingsReducer),
});
